// src/pages/Login.jsx
import React, { useState } from "react";
import api from "./api";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      console.log("Attempting login with:", { email, password });
      const res = await api.post("/login", { email, password });

      console.log("Login successful:", res.data);

      // save token
      localStorage.setItem("token", res.data.token);

      navigate("/dashboard");
    } catch (err) {
      alert("Invalid credentials");
    }
  };

  return (
  <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
    <div
      className="bg-white shadow rounded p-4"
      style={{ width: "100%", maxWidth: 360 }}
    >
      {/* 🔹 Logo Section */}
      <div className="text-center mb-4">
  <img
    src="/logo.png"
    alt="Shiv Trade Link"
    style={{ width: 140, display: "block", margin: "0 auto" }}
  />

  <div className="mt-2">
    <small className="text-muted">Welcome back 👋</small>
  </div>
</div>

      {/* 🔹 Login Form */}
      <form onSubmit={handleLogin}>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

 <div className="mb-3 position-relative">
  <input
    type={showPassword ? "text" : "password"}
    className="form-control pe-5"
    placeholder="Password"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    required
  />

  <span
    onClick={() => setShowPassword(!showPassword)}
    className="position-absolute top-50 end-0 translate-middle-y me-3"
    style={{ cursor: "pointer", color: "#6c757d" }}
  >
    {showPassword ? <FaEyeSlash /> : <FaEye />}
  </span>
</div>





        <button className="btn btn-primary w-100 fw-semibold">
          Login
        </button>
      </form>

      {/* 🔹 Footer */}
      <div className="text-center mt-3">
        <small className="text-muted">
          © {new Date().getFullYear()} Shiv Trade Link
        </small>
      </div>
    </div>
  </div>
);
}
export default Login;
